import React from 'react';

const ObstacleOnePage = React.lazy(() => import('@apps/Obstacles/components/ObstacleOnePage'));
const ObstaclesByTypePage = React.lazy(
  () => import('@apps/Obstacles/components/ObstaclesByTypePage'),
);
const ObstaclesPage = React.lazy(() => import('@apps/Obstacles/components/ObstaclesPage'));

import { IPohodnikRouterItem } from '.';

const obstaclesRoutes: Array<IPohodnikRouterItem> = [
  {
    path: '/obstacles/:type/:id',
    component: ({
      match: {
        params: { id },
      },
    }) => <ObstacleOnePage id={+id} />,
    title: 'Просмотр локального препятствия или POI',
  },
  {
    path: '/obstacles/peaks',
    component: () => <ObstaclesByTypePage type="peaks" />,
    title: 'Список вершин',
  },
  {
    path: '/obstacles/passes',
    component: () => <ObstaclesByTypePage type="passes" />,
    title: 'Список перевалов',
  },
  {
    path: '/obstacles/poi',
    component: () => <ObstaclesByTypePage type="poi" />,
    title: 'Список POI',
  },
  {
    path: '/obstacles',
    component: () => <ObstaclesPage />,
    title: 'Список локальных препятствий и POI',
  },
];

export default obstaclesRoutes;
